import Module from "global/sparta-module-utility";
import spartaStickyUtility from "global/sparta-sticky-utility";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/global/title-module/3.2.0/css/title-module.scss.css";

const scope = {};
class titleModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'title-module', precompiled: {"1":function(container,depth0,helpers,partials,data) {
    return " spa-sticky";
},"3":function(container,depth0,helpers,partials,data) {
    return " spa-page-title--has-flagscape";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " spa-page-title--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1), depth0));
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " spa-page-title--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.textColor : stack1), depth0))
    + "-text";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : {},depth0,{"name":"each","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = (helpers.compare || (depth0 && depth0.compare) || helpers.helperMissing).call(depth0 != null ? depth0 : {},(data && data.key),"==",((stack1 = (depths[2] != null ? depths[2].page : depths[2])) != null ? stack1.pageID : stack1),{"name":"compare","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "\n            <"
    + ((stack1 = helpers["with"].call(alias1,((stack1 = (depths[2] != null ? depths[2].module : depths[2])) != null ? stack1.titleHeadingTag : stack1),{"name":"with","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " data-font=\"cnx-regular\" class=\"heading title-heading\" id=\"skip-to-h1\""
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depths[2] != null ? depths[2].module : depths[2])) != null ? stack1.titleHeadingRole : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " aria-level=\"1\">\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0["default"] : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.program(18, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n\n            </"
    + ((stack1 = helpers["with"].call(alias1,((stack1 = (depths[2] != null ? depths[2].module : depths[2])) != null ? stack1.titleHeadingTag : stack1),{"name":"with","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.program(26, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + ">\n\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "");
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " role=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[2] != null ? depths[2].module : depths[2])) != null ? stack1.titleHeadingRole : stack1), depth0))
    + "\"";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + ((stack1 = container.lambda((depth0 != null ? depth0["default"] : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.small : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.program(21, data, 0),"data":data})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                  "
    + ((stack1 = container.lambda((depth0 != null ? depth0.small : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.medium : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.program(24, data, 0),"data":data})) != null ? stack1 : "");
},"22":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = container.lambda((depth0 != null ? depth0.medium : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = container.lambda((depth0 != null ? depth0.large : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"26":function(container,depth0,helpers,partials,data) {
    return "h1";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "\n  <style type=\"text/css\">\n    .spa-page-title.spa-page-title--has-flagscape.spa-page-title--red {\n      background-image: url('"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.globalHeader : depth0)) != null ? stack1.title : stack1)) != null ? stack1.flagscapeRedImage : stack1), depth0))
    + "');\n    }\n\n    .spa-page-title.spa-page-title--has-flagscape.spa-page-title--crimson {\n      background-image: url('"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.globalHeader : depth0)) != null ? stack1.title : stack1)) != null ? stack1.flagscapeCrimsonImage : stack1), depth0))
    + "');\n    }\n\n    .spa-page-title.spa-page-title--has-flagscape.spa-page-title--gray {\n      background-image: url('"
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.globalHeader : depth0)) != null ? stack1.title : stack1)) != null ? stack1.flagscapeGrayImage : stack1), depth0))
    + "');\n    }\n  </style>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "\n<div class=\"spa-page-title"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.isSticky : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.flagscape : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = (helpers.compare || (depth0 && depth0.compare) || helpers.helperMissing).call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.textColor : stack1),"!=","none",{"name":"compare","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n  <div class=\"spa-page-title-inset row\">\n    <div class=\"columns small-12\">\n\n"
    + ((stack1 = helpers.each.call(alias1,((stack1 = (depth0 != null ? depth0.sitePageTitles : depth0)) != null ? stack1.pageTitles : stack1),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n  </div>\n</div>\n\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.flagscape : stack1),{"name":"if","hash":{},"fn":container.program(28, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true,"useDepths":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new titleModuleTemplates();
